export default {
  selectedPanel: null,
  loadingDetail: false,
  errorDetail: null,
  searchResults: [],
  searchLoading: false,
  searchError: null,
  isSearchActive: false,
};
